/**
 * @ External Dependecies
 */
import styled from 'styled-components';

export const TabContentContainer = styled.div`
  overflow: visible !important;
`;
